import React from "react";
import logo from "./logo.svg";
// Styles
import classes from "./App.module.scss";
// Components
import Challenge from "./components/Challenge";
// Data
import data from "./data/challenges.json";

const App = () => {
  return (
    <main className={classes.App}>
      <section className={classes.Background}>
        <img src={logo} className={classes.Logo} alt='logo' />
      </section>
      <section className={classes.Content}>
        <header className={classes.Title}>
          <h1>frontend mentor challenges</h1>
        </header>
        <div className={classes.ChallengesList}>
          {data.challenges.map(item => {
            return <Challenge key={item.id} {...item} />;
          })}
        </div>
      </section>
      <footer className={classes.Footer}>
        <p>
          Crafted with &hearts; by{" "}
          <a
            href='https://github.com/Joker-Bat'
            target='_blank'
            rel='noreferrer'
          >
            silverdev
          </a>
        </p>
      </footer>
    </main>
  );
};

export default App;
